<template>
  <div class="main">
    <div id="top" ref="top"></div>
    <searchhead-checkbox searchType="2" :hideSome='true' @resetUnlockQ="resetUnlockQ" @set-condition="setCondition" :searchTitle="'新注册企业查询'" :isNewCompany="true"></searchhead-checkbox>
    <div v-loading.lock="waiting">
      <company-card-list @isUnlock-Change="isUnlockChange" :resetUnlockS="isUnlock" :companyType="2" class="ccl" style="padding-bottom:0" ref="cardlist" :batchActions="batchActions" :list="list"
        @handle-page-num="handlePageNum" @handle-page="handlePage" @getData="getData">
        <!-- <div style="display: flex;justify-content: space-between; padding-right: 24px">
          <div>新增注册企业</div>
          <div style="color: #999;">近一年内新增注册企业</div>
        </div> -->
        <div class="font-15-md">
          {{listTip}}<span class="blueColor" style="color: #5088FF;"> {{ _totalElements }} </span>家企业
        </div>

        <template v-slot:beforeBatch>
          <el-button class="gbBatchBtn" :loading="actionLoading" type="info" plain size="small" v-interestExpire @click="batchUnlockFnbefore">解锁前500</el-button>
        </template>
        <template v-slot:two>
          <intel-sort @sortChange="sortChange" :value="sortValue"></intel-sort>
        </template>

      </company-card-list>
    </div>
    <robot />

    <!-- 右侧悬浮箭头 -->
    <right-float ref="rightFloat" :globalRfType="false" @scrollToView="scrollToView"></right-float>
    <div id="bottom" ref="bottom"></div>
    <unlock-dialog-batch :show.sync="unlockDialogShowBatch" :maxTotal="list.total" :list="companyList" title="批量解锁" :confirmPromise="contactsNumBatchConfirmBatch"></unlock-Dialog-Batch>
    <!-- 批量解锁提示 -->
    <batch-unlock-tip ref="batchUnlockTip"></batch-unlock-tip>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import SearchheadCheckbox from '../components/searchHeadCheckBox'
import CompanyCardList from '../components/companyCardList'
import { searchByCondition, searchByConditionUnlock } from '../api/index'
import Robot from '../components/robot'
import intelSort from '@/views/wigects/intelSort'
import unlockDialogBatch from '../components/unlockDialogBatch'
import batchUnlockTip from '@/components/batchUnlockTip'
import RightFloat from '@/components/rightFloatBtn'
export default {
  provide() {
    return {
      unlockSourceType: 2
    }
  },
  components: {
    SearchheadCheckbox,
    CompanyCardList,
    Robot,
    intelSort,
    unlockDialogBatch,
    batchUnlockTip,
    RightFloat
  },
  data() {
    return {
      optionsTime: [
        {
          value: null,
          label: '默认排序'
        },
        {
          value: 1,
          label: '成立时间从早到晚'
        }, {
          value: 2,
          label: '成立时间从晚到早'
        }
      ],
      sortType: { sortField: "establishTime", sortType: 2 },
      sortValue: "establishTime-2",
      totalElements: 0,
      listTip: '近12个月内新注册',
      list: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
        tab: 1,
        tableData: []
      },
      categoryId: '',
      areaCodeId: '',
      waiting: false,
      lastParams: {},
      filterValue: 'word',
      unlockDialogShowBatch: false,
      companyList: [],
      actionLoading: false,
      scrollTop: 0,
      isUnlock: false
    }
  },
  computed: {
    ...mapState({
      surplus: state => state.user.surplus,
      staffInfo: state => state.user.staffInfo
    }),
    _totalElements() {
      if (this.totalElements < 100) return this.totalElements
      if (this.totalElements < 200000) return `${this.totalElements.toString().split('').reduce((res, v) => res ? res + 0 : v, '')}+`
      return '200000+'
    },
    batchActions() {
      return this.surplus < 1 ? [false, true, false] : [true, true, false]
    }
  },
  beforeDestroy() {
    this.getPageWrapPadding()
    this.listenerFunction()
  },
  mounted() {
    // this.newCompany()
    // this.setPageWrapPadding()
    this.listenerFunction()
  },
  methods: {
    resetUnlockQ(val) {
      this.isUnlock = val
    },
    listenerFunction(e) {
      document.addEventListener('scroll', this.handleScroll, true)
    },
    handleScroll(event) {
      this.scrollTop = event.target.scrollTop
    },
    scrollToView(val) {
      document.getElementById(val).scrollIntoView({
        block: 'start',
        inline: 'nearest',
        behavior: 'smooth'
      })
    },
    // 过滤解锁
    isUnlockChange(val) {
      this.isUnlock = val
      this.newCompany()
    },
    sortChange(v) {
      this.list.pageNum = 1
      this.sortType = v
      this.newCompany()
    },
    setCondition(val) {
      this.list.pageNum = 1
      this.lastParams = val
      this.newCompany()
    },
    updateTip() {
      const { estiblishTime } = this.lastParams
      if (!estiblishTime || estiblishTime.length === 0) {
        this.listTip = '近12个月内新注册' // default
      } else if (estiblishTime.includes('1-12个月')) {
        this.listTip = '近1-12个月内新注册'
      } else if (estiblishTime.includes('1个月以内')) {
        this.listTip = '近1个月内新注册'
      }
    },
    removeHtml(str) {
      const reTag = /<(?:.|\s)*?>/g
      return str.replace(reTag, '').replace(/&nbsp;/ig, '')
    },
    async newCompany() {
      this.waiting = true
      let isUnlockN = this.isUnlock ? 1 : 0
      const params = {
        pageNum: this.list.pageNum,
        pageSize: this.list.pageSize,
        ...(this.sortType || {}),
        word: this.$route.query.word && this.$route.query.word.trim(),
        isUnLock: parseInt(isUnlockN),
        estiblishTime: ["12个月以内"],//默认值 手动选择会被覆盖
        ...this.lastParams
      }
      try {
        const { data } = await searchByCondition(params)

        this.list.total = data.total > 15000 ? 15000 : data.total
        this.totalElements = data.total
        this.list.tableData = data.items
        this.updateTip()
      } catch (error) { } finally {
        this.waiting = false
      }
    },
    getData() {
      this.newCompany()
    },
    handlePage(val) {
      if (this.list.pageNum !== val) {
        this.list.pageNum = val
        this.newCompany()
      }
    },
    handlePageNum(val) {
      this.list.pageNum = 1
      this.list.pageSize = val
      this.newCompany()
    },
    // 批量解锁前500
    batchUnlockFnbefore() {
      // 重新获取解锁数据
      this.$store.commit('SET_FREQUENCY', this.$store.state.user.frequency + 1)
      this.unlockDialogShowBatch = true
    },
    async contactsNumBatchConfirmBatch() {
      let isUnlockN = this.isUnlock ? 1 : 0
      const params = {
        pageNum: this.list.pageNum,
        pageSize: this.list.pageSize,
        source: 2,
        ...(this.sortType || {}),
        word: this.$route.query.word && this.$route.query.word.trim(),
        estiblishTime: ["12个月以内"],//默认值 手动选择会被覆盖
        ...this.lastParams,
        isUnLock: parseInt(isUnlockN)
      }
      try {
        const { data, code } = await searchByConditionUnlock(params)
        if (code === 200) {
          if (this.staffInfo.demonstrationTag != 1) {
            this.$message.warning('批量解锁中，所需时长5分钟，请稍后在解锁列表中查看')
          }
          this.newCompany()
          this.$refs.batchUnlockTip.getUnlockBatchTip()
          this.$refs.batchUnlockTip.tipTitleF('2')
        }
      } catch (error) { } finally {
      }
    }

  }
}
</script>

<style lang="scss" scoped>
.font-15-md {
  font-size: 15px;
  font-weight: 600;
  color: rgba(52, 57, 81, 0.7);
}
.filtrate-time {
  position: absolute;
  top: 0px;
  right: 0px;
  display: flex;
  align-items: center;
  height: 100%;

  // position: absolute;
  // top: 0px;
  // right: 200px;

  // /deep/ .el-input__inner {
  //   border: none;
  //   background: #f0f2f5;
  // }

  // /deep/ .el-input__suffix {
  //   i {
  //     display: none;
  //   }
  // }
}
.ccl {
  // width: calc(100% - 30px);
  margin: 0 auto;
  margin-bottom: 24px;
  margin-top: 30px;
  /deep/ .recommend {
    margin: 0;
  }
}
.cls-title-001 {
  font-size: 16px;
  font-weight: bold;
  color: rgba(52, 57, 81, 0.7);
  line-height: 36px;
}
.goUPDown {
  position: fixed;
  right: 14px;
  bottom: 70px;
  img {
    cursor: pointer;
    display: block;
    margin: auto;
  }
}
.gbBatchBtn {
  &.el-button {
    color: #333333;
    background: rgba(255, 255, 255, 0.2);
    box-shadow: 0px 2px 4px 0px #edeef3;
    border-radius: 4px;
    border: 1px solid #bbbeca;
    margin-left: 8px;
  }
}
</style>
